/**
 * Adds a property to an object if the condition value exists (not undefined or null)
 * @param {any} value - The value to check and use
 * @param {string} key - The key for the property
 * @param {any} [customValue] - Optional custom value to use instead of the original value
 * @returns {Object} Object with the property if condition is met, empty object otherwise
 */
export const addPropertyIfExists = (value, key, customValue) => {
    if (value) {
        return { [key]: customValue !== undefined ? customValue : value };
    }
    return {};
};

/**
 * Converts boolean values to custom text
 * @param {boolean} value - The boolean value to convert
 * @param {string} [trueText='Yes'] - Text to use for true values
 * @param {string} [falseText='No'] - Text to use for false values
 * @returns {string} The mapped text value
 */
export const booleanToText = (value, trueText = 'Yes', falseText = 'No') => {
    return value === true ? trueText : falseText;
};

/**
 * Adds a property with a formatted boolean value if the condition exists
 * @param {boolean} value - The boolean value to check and format
 * @param {string} key - The key for the property
 * @param {string} [trueText='Yes'] - Text to use for true values
 * @param {string} [falseText='No'] - Text to use for false values
 * @returns {Object} Object with the formatted property if condition is met, empty object otherwise
 */
export const addBooleanPropertyIfExists = (value, key, trueText = 'Yes', falseText = 'No') => {
    if (value !== undefined) {
        return { [key]: booleanToText(value, trueText, falseText) };
    }
    return {};
};
export default {};
